import { render } from "./slider-tags-form.vue?vue&type=template&id=5701825c&ts=true"
import script from "./slider-tags-form.vue?vue&type=script&lang=ts"
export * from "./slider-tags-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__